import React, { useState } from 'react';
import { X } from 'lucide-react';
import { blogPosts } from '../mockData';

const ExploreIdeas = () => {
  const [selectedPost, setSelectedPost] = useState(null);

  const openPost = (post) => {
    setSelectedPost(post);
    document.body.style.overflow = 'hidden';
  };

  const closePost = () => {
    setSelectedPost(null);
    document.body.style.overflow = 'auto';
  };

  return (
    <div className="bg-[#f5f2ed] pt-24">
      {/* Hero */}
      <section className="section-padding">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-5xl md:text-7xl font-['Playfair_Display'] text-[#1a1a1a] mb-6 fade-in">
            Explore Ideas
          </h1>
          <p className="text-lg text-[#9c9590] fade-in" style={{ animationDelay: '0.2s' }}>
            Perspectives on architecture, materials, and building with intention.
          </p>
        </div>
      </section>

      {/* Blog Listing */}
      <section className="section-padding bg-white">
        <div className="max-w-4xl mx-auto space-y-12">
          {blogPosts.map((post, index) => (
            <article
              key={post.id}
              className="border-b border-[#9c9590]/20 pb-12 last:border-b-0 cursor-pointer group fade-in"
              style={{ animationDelay: `${index * 0.1}s` }}
              onClick={() => openPost(post)}
            >
              <p className="text-sm text-[#9c9590] mb-3">{post.date}</p>
              <h2 className="text-3xl md:text-4xl font-['Playfair_Display'] text-[#1a1a1a] mb-4 group-hover:text-[#b8986e] transition-colors">
                {post.title}
              </h2>
              <p className="text-[#9c9590] leading-relaxed">{post.excerpt}</p>
            </article>
          ))}
        </div>
      </section>

      {/* Blog Post Modal */}
      {selectedPost && (
        <div className="fixed inset-0 z-50 bg-[#f5f2ed] overflow-y-auto">
          <div className="min-h-screen px-6 py-24">
            {/* Close Button */}
            <button
              onClick={closePost}
              className="fixed top-6 right-6 text-[#1a1a1a] hover:text-[#b8986e] transition-colors z-50"
              aria-label="Close"
            >
              <X size={32} />
            </button>

            <article className="max-w-3xl mx-auto">
              <p className="text-sm text-[#9c9590] mb-4">{selectedPost.date}</p>
              <h1 className="text-4xl md:text-6xl font-['Playfair_Display'] text-[#1a1a1a] mb-12 leading-tight">
                {selectedPost.title}
              </h1>
              <div
                className="prose prose-lg max-w-none text-[#1a1a1a]"
                style={{
                  lineHeight: '1.8',
                  fontSize: '1.125rem'
                }}
              >
                {selectedPost.content.split('\n\n').map((paragraph, index) => {
                  if (paragraph.startsWith('**') && paragraph.endsWith('**')) {
                    return (
                      <h2
                        key={index}
                        className="text-2xl font-['Playfair_Display'] text-[#1a1a1a] mt-12 mb-6"
                      >
                        {paragraph.replace(/\*\*/g, '')}
                      </h2>
                    );
                  }
                  return (
                    <p key={index} className="mb-6 text-[#1a1a1a] leading-relaxed">
                      {paragraph.split('\n').map((line, i) => (
                        <React.Fragment key={i}>
                          {line.startsWith('**') && line.includes('**') ? (
                            <strong className="font-semibold">{line.replace(/\*\*/g, '')}</strong>
                          ) : (
                            line
                          )}
                          {i < paragraph.split('\n').length - 1 && <br />}
                        </React.Fragment>
                      ))}
                    </p>
                  );
                })}
              </div>
            </article>
          </div>
        </div>
      )}
    </div>
  );
};

export default ExploreIdeas;
